import { z } from 'zod';
import { paginationFiltersSchema } from 'utils/schemas';
import { voucherStatuses } from 'store/vouchers';

export const adminCardVouchersFiltersSchema = z
  .object({
    search: z.string().catch(''),
    status: z.array(z.enum(voucherStatuses)).catch([]),
    prices: z.array(z.string()).catch([]),
  })
  .merge(paginationFiltersSchema);
